import { render, staticRenderFns } from "./orderEntering.vue?vue&type=template&id=21dbc216&scoped=true"
import script from "./orderEntering.vue?vue&type=script&lang=js"
export * from "./orderEntering.vue?vue&type=script&lang=js"
import style0 from "./orderEntering.vue?vue&type=style&index=0&id=21dbc216&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dbc216",
  null
  
)

export default component.exports